export default __webpack_public_path__ + "static/media/workspaceuserhighlight.fcb4d8cf.svg";